module.exports = __webpack_public_path__ + "static/media/casellario.44fb8acc.odt";